import { Form, FormField, FormFieldConditions, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';

export interface MantenimientoCargoFormModel {
  nombre: string;
  precio_hora: number;
}

/** Form used to append a cargo from the maintenance list modal. */
export class MantenimientoCargoFormDefinition {
  public readonly formFields: Form<MantenimientoCargoFormModel>;

  constructor() {
    this.formFields = {
      name: 'mantenimiento-cargos',
      header: '',
      type: FormType.CREATION,
      sections: [this.createSection()],
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private createSection(): FormSection<MantenimientoCargoFormModel> {
    return {
      name: '',
      fields: [
        this.textField('nombre', 'Cargo', 1, InputType.TEXT),
        this.textField('precio_hora', 'Precio/Hora', 2, InputType.NUMERIC),
      ],
      width: 12,
      isVisible: true,
      order: 1,
    };
  }

  private textField(name: string, label: string, order: number, inputType: InputType): FormField<MantenimientoCargoFormModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
      },
      width: 6,
      conditions: this.conditions(),
      order,
    };
  }

  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }
}
